import { Button } from '@/shared/components';
import { clockFromMinutes } from '../resourceModel';
import type { GridSelection } from './resourceGridModel';

/**
 * Dunkle Leiste direkt unter dem Raster (Board „Belegung · Ressourcen“): was markiert ist, „Zeit sperren“ –
 * auch ohne Markierung, für Tastatur und Touch – und wie man aufhebt.
 */
export function ResourceSelectionBar({
  selection,
  resourceName,
  onBlock,
  onClear,
}: {
  selection: GridSelection | null;
  resourceName?: string;
  onBlock: () => void;
  onClear: () => void;
}) {
  return (
    <div
      role="region"
      aria-label="Zeit markieren"
      className="bg-ink flex flex-wrap items-center gap-2.5 px-[18px] py-3.5 text-white"
    >
      <span className="grow text-sm font-bold" aria-live="polite">
        {selection
          ? `${resourceName ?? ''} · ${clockFromMinutes(selection.startMinute)} – ${clockFromMinutes(selection.endMinute)} markiert`
          : 'Ziehen markiert eine Zeit.'}
      </span>
      {selection && (
        <button
          type="button"
          onClick={onClear}
          className="text-on-forest-soft min-h-11 px-2 text-[13px] font-bold"
        >
          Markierung leeren
        </button>
      )}
      <Button variant="secondary" className="text-ink min-h-11 bg-white" onClick={onBlock}>
        Zeit sperren
      </Button>
      <span className="text-on-forest-soft basis-full text-xs">
        Belegte Zeit anklicken zum Aufheben – bei bezahlten nur mit Bestätigung.
      </span>
    </div>
  );
}
